import { useContext } from 'react';

import SecondaryPageLayout from '@/Layout/SecondaryPageLayout';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import SingleSignOnForm from '@/components/SingleSignOnForm';
import { useSieMethods } from '@/hooks/use-sie';

const SingleSignOnEmail = () => {
  const { experienceSettings } = useContext(PageContext);
  const { singleSignOnEnabled } = useSieMethods();

  // Hide back button if forceSsoSignIn is enabled
  const isNavBarHidden = experienceSettings?.forceSsoSignIn && singleSignOnEnabled;

  return (
    <SecondaryPageLayout
      title="action.single_sign_on"
      description="description.single_sign_on_email_form"
      isNavBarHidden={isNavBarHidden}
    >
      <SingleSignOnForm />
    </SecondaryPageLayout>
  );
};

export default SingleSignOnEmail;
